// features/buyer/buyerSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { buyerService } from "./buyeService";
import { order } from "@mui/system";

// View profile
export const fetchBuyerProfile = createAsyncThunk(
  "buyer/fetchProfile",
  async (_, thunkAPI) => {
    try {
      const response = await buyerService.getProfile();
      // console.log('Response Profile:', response);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.message || "Failed to fetch profile"
      );
    }
  }
);

// Update profile
export const updateBuyerProfile = createAsyncThunk(
  "buyer/updateProfile",
  async (profileData, thunkAPI) => {
    try {
      const response = await buyerService.updateProfile(profileData);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.message || "Failed to update profile"
      );
    }
  }
);

//View Addresses
export const fetchBuyerAddresses = createAsyncThunk(
  "buyer/fetchAddresses",
  async (addressData, thunkAPI) => {
    try {
      const response = await buyerService.getAddressList(addressData);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.message || "Failed to fetch address list"
      );
    }
  }
);

// Update profile
export const updateBuyerAddress = createAsyncThunk(
  "buyer/updateAddress",
  async (addressData, thunkAPI) => {
    try {
      const response = await buyerService.updateAddress(addressData);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.message || "Failed to update address"
      );
    }
  }
);

// Change password
export const changeBuyerPassword = createAsyncThunk(
  "buyer/changePassword",
  async (passwordData, thunkAPI) => {
    try {
      const response = await buyerService.changePassword(passwordData);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.message || "Failed to change password"
      );
    }
  }
);

// Upload KYC
export const uploadBuyerKyc = createAsyncThunk(
  "buyer/uploadKyc",
  async (formData, thunkAPI) => {
    try {
      const response = await buyerService.uploadKyc(formData);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message || "Failed to upload KYC");
    }
  }
);

// Get KYC list
export const fetchBuyerKycList = createAsyncThunk(
  "buyer/fetchKycList",
  async (_, thunkAPI) => {
    try {
      const documents = await buyerService.getKycList();
      return documents;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.message || "Failed to fetch KYC list"
      );
    }
  }
);

// Get all products
export const fetchAllProducts = createAsyncThunk(
  "buyer/fetchAllProducts",
  async (_, thunkAPI) => {
    try {
      const response = await buyerService.getAllProducts();
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.message || "Failed to fetch products"
      );
    }
  }
);

// Get product detail
export const fetchProductDetail = createAsyncThunk(
  "buyer/fetchProductDetail",
  async (productData, thunkAPI) => {
    try {
      const response = await buyerService.getProductDetail(productData);
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.message || "Failed to fetch product detail"
      );
    }
  }
);

// Random Products
export const fetchRandomProducts = createAsyncThunk(
  "buyer/fetchRandomProducts",
  async (_, thunkAPI) => {
    try {
      const response = await buyerService.randomProducts();
      return response.data.products || [];
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.message || "Failed to fetch random products"
      );
    }
  }
);

// Filter products
export const filterBuyerProducts = createAsyncThunk(
  "buyer/filterBuyerProducts",
  async ({ categoryId, subcategoryId }, thunkAPI) => {
    try {
      const params = { category_id: categoryId };
      if (subcategoryId) params.subcategory_id = subcategoryId;

      const response = await buyerService.filterProducts(params);
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.message || "Failed to fetch product filters"
      );
    }
  }
);

// Get subcategories
export const fetchSubcategories = createAsyncThunk(
  "buyer/fetchSubcategories",
  async (categoryId, thunkAPI) => {
    try {
      // const params = { category_id: categoryId };
      const response = await buyerService.getSubcategories(categoryId);
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.message || "Failed to fetch subcategories"
      );
    }
  }
);

// Get My bids
export const fetchMyBids = createAsyncThunk(
  "buyer fetchMyBids",
  async (_, thunkAPI) => {
    try {
      const response = await buyerService.getBidList();
      // console.log("BId Res:", response.data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message || "Failed to fetch bids");
    }
  }
);

// Place bid
export const placeBid = createAsyncThunk(
  "buyer/placeBid",
  async (bidData, thunkAPI) => {
    try {
      const response = await buyerService.placeBid(bidData);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message || "Failed to place bids");
    }
  }
);

// Accept bid
export const acceptBid = createAsyncThunk(
  "buyer/acceptBid",
  async (id, thunkAPI) => {
    try {
      const response = await buyerService.acceptBid(id);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message || "Failed to accept bids");
    }
  }
);

// Reject bid
export const rejectBid = createAsyncThunk(
  "buyer/rejectBid",
  async ({ id, reason }, thunkAPI) => {
    try {
      const response = await buyerService.rejectBid(id, { reason });
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message || "Failed to reject bids");
    }
  }
);

//Get Buyer DashBoard
export const fetchBuyerDashboard = createAsyncThunk(
  "buyer/getBuyerDashboard",
  async (_, thunkAPI) => {
    try {
      const response = await buyerService.getBuyerDashboard();
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.message || "Failed to fetch Buyer Dashboard"
      );
    }
  }
);

// My Orders
export const fetchMyOrders = createAsyncThunk(
  "buyer/fetchMyOrders",
  async (_, thunkAPI) => {
    try {
      const response = await buyerService.myOrders();
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.message || "Failed to fetch orders"
      );
    }
  }
);

// Order Details
export const fetchOrderDetails = createAsyncThunk(
  "buyer/fetchOrderDetails",
  async (id, thunkAPI) => {
    try {
      const response = await buyerService.orderDetails(id);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.message || "Failed to fetch order details"
      );
    }
  }
);

// Order Cancel
export const cancelOrder = createAsyncThunk(
  "buyer/cancelOrder",
  async (id, thunkAPI) => {
    try {
      const response = await buyerService.orderCancel(id);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.message || "Failed to cancel order"
      );
    }
  }
);

// Order Track
export const trackOrder = createAsyncThunk(
  "buyer/trackOrder",
  async (id, thunkAPI) => {
    try {
      const response = await buyerService.orderTrack(id);
      // console.log("Track Response:", response);
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message || "Failed to track order");
    }
  }
);

// Order Place
export const placeOrder = createAsyncThunk(
  "buyer/placeOrder",
  async (data, thunkAPI) => {
    try {
      const response = await buyerService.orderPlace(data);
      // console.log("Place order response:", response.data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message || "Failed to place order");
    }
  }
);

// Order Summary
export const getOrderSummary = createAsyncThunk(
  "buyer/orderSummary",
  async (id, thunkAPI) => {
    try {
      const response = await buyerService.orderSummary(id);
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.message || "Failed to get Order Summary"
      );
    }
  }
);

// Generate Invoice
export const generateInvoice = createAsyncThunk(
  "buyer/generateInvoice",
  async (data, thunkAPI) => {
    try {
      const response = await buyerService.generateInvoice(data);
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error?.response?.data || error.message || "Failed to generate invoice"
      );
    }
  }
);

//Tpi Request
export const createTpiRequest = createAsyncThunk(
  "buyer/createTpiRequest",
  async (id, thunkAPI) => {
    try {
      const response = await buyerService.createTpiRequest(id)
      return response
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.message || "Failed to get payment methods"
      )
    }
  }
)

// Payment Methods
export const getPaymentMethods = createAsyncThunk(
  "buyer/getPaymentMethods",
  async (_, thunkAPI) => {
    try {
      const response = await buyerService.paymentMethods();
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.message || "Failed to get payment methods"
      );
    }
  }
);

// Checkout Session
export const createCheckoutSession = createAsyncThunk(
  "buyer/createCheckoutSession",
  async (data, thunkAPI) => {
    try {
      const response = await buyerService.checkOutSession(data);
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.message || "Failed to create checkout session"
      );
    }
  }
);

// Payment Status
export const getPaymentStatus = createAsyncThunk(
  "buyer/getPayementStatus",
  async (id, thunkAPI) => {
    try {
      const response = await buyerService.paymentStatus(id);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.message || "Failed to get payment status"
      );
    }
  }
);

//Mark As Complete
export const markAsComplete = createAsyncThunk(
  "buyer/markAsComplete",
  async (id, thunkAPI) => {
    try {
      const response = await buyerService.markComplete(id);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.message || "Failed to mark as complete order"
      );
    }
  }
);

// Market Data
export const getMarketData = createAsyncThunk(
  "buyer/getMarketData",
  async (_, thunkAPI) => {
    try {
      const data = await buyerService.marketData();
      // console.log("Response Market:", data);
      return data;
    } catch (error) {
      console.error("Market fetch error:", error);
      return thunkAPI.rejectWithValue(
        error.message || "Failed to get market data"
      );
    }
  }
);

// Reverse Bids
export const fetchReverseBids = createAsyncThunk(
  "buyer/fetchReverseBids",
  async (_, thunkAPI) => {
    try {
      const response = await buyerService.reverseBids();
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.message || "Failed to fetch reverse bids"
      );
    }
  }
);

// Reverse Bid Store
export const storeReverseBid = createAsyncThunk(
  "buyer/storeReverseBid",
  async (data, thunkAPI) => {
    try {
      const response = await buyerService.reverseBidStore(data);
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.message || "Failed to store reverse bid"
      );
    }
  }
);

// Reverse Bid Details
export const fetchReverseBidDetails = createAsyncThunk(
  "buyer/fetchReverseBidDetails",
  async (id, thunkAPI) => {
    try {
      console.log('Id received in thunk:', id)
      const response = await buyerService.reverseBidDetails(id);
      console.log('Thunk details:', response.data)
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.message || "Failed to fetch reverse bid details"
      );
    }
  }
);

// Reverse Bid Accept
export const acceptReverseBid = createAsyncThunk(
  "buyer/acceptReverseBid",
  async (id, thunkAPI) => {
    try {
      const response = await buyerService.reverseBidAccept(id);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.message || "Failed to accept reverse bid"
      );
    }
  }
);

//Order Shipping Details
export const orderShippingDetails = createAsyncThunk(
  "buyer/fetchOrderShippingDetails",
  async ({ id, data }, thunkAPI) => {
    try {
      console.log("form data in thunk:", data);
      const response = await buyerService.orderShippingDetails(id, data);
      console.log("response in thunk:", response);
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.message || "Failed to fetch order shipping details"
      );
    }
  }
);

// Shipping Details
export const fetchShippingDetails = createAsyncThunk(
  "buyer/fetchShippingDetails",
  async (id, thunkAPI) => {
    try {
      const response = await buyerService.shippingDetails(id);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.message || "Failed to fetch shipping details"
      );
    }
  }
);

// Accept Order
export const acceptOrder = createAsyncThunk(
  "buyer/acceptOrder",
  async (id, thunkAPI) => {
    try {
      const response = await buyerService.acceptOrder(id);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.message || "Failed to accept order"
      );
    }
  }
);

// Dispute Order
export const disputeOrder = createAsyncThunk(
  "buyer/disputeOrder",
  async ({ id, data }, thunkAPI) => {
    try {
      console.log("Disputing Order with ID:", id);
      const response = await buyerService.disputeOrder(id, data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.message || "Failed to dispute order"
      );
    }
  }
);

// Contact Us
export const contactUs = createAsyncThunk(
  "buyer/contactUs",
  async (data, thunkAPI) => {
    try {
      const response = await buyerService.contactUs(data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.message || "Failed to submit contact us request"
      );
    }
  }
);

// Get All Offers
export const fetchAllOffers = createAsyncThunk(
  "buyer/fetchAllOffers",
  async (_, thunkAPI) => {
    try {
      const response = await buyerService.getAllOffers();
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.message || "Failed to fetch all offers"
      );
    }
  }
);

// Offers Details
export const fetchOfferDetails = createAsyncThunk(
  "buyer/fetchOfferDetails",
  async (id, thunkAPI) => {
    try {
      const response = await buyerService.getOffersDetail(id);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.message || "Failed to fetch offer details"
      );
    }
  }
);

// Create Offers
export const createOffers = createAsyncThunk(
  "buyer/createOffers",
  async (data, thunkAPI) => {
    try {
      const response = await buyerService.createOffers(data);
      console.log("first");
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.message || "Failed to create offer"
      );
    }
  }
);

// Update Offers
export const updateOffers = createAsyncThunk(
  "buyer/updateOffers",
  async ({ id, data }, thunkAPI) => {
    try {
      const response = await buyerService.updateOffers(id, data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.message || "Failed to update offer"
      );
    }
  }
);

// Delete Offers
export const deleteOffers = createAsyncThunk(
  "buyer/deleteOffers",
  async (id, thunkAPI) => {
    try {
      const response = await buyerService.deleteOffers(id);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.message || "Failed to delete offer"
      );
    }
  }
);

//Calculate Price
export const calculatePrice = createAsyncThunk(
  "buyer/calculatePrice",
  async (data, thunkAPI) => {
    try {
      const response = await buyerService.calculatePrice(data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.message || "Failed to calculate product price"
      );
    }
  }
);

//Get Metal Code
export const fetchMetalCode = createAsyncThunk(
  "buyer/fetchMetalCode",
  async (data, thunkAPI) => {
    try {
      const response = await buyerService.getMetalCode(data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.message || "Failed to fetch metal code"
      );
    }
  }
);

// Specifications
export const fetchSpecifications = createAsyncThunk(
  "buyer/fetchSpecifications",
  async (id, thunkAPI) => {
    try {
      const response = await buyerService.getSpecifications(id);
      // console.log("Specification response:", response.data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.message || "Failed to fetch Subcategories"
      );
    }
  }
);

//Counter Offer
export const respondCounterOffer = createAsyncThunk(
  "buyer/responsCounterOffer",
  async ({ id, data }, thunkAPI) => {
    try {
      const response = await buyerService.respondCounterOffer(id, data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.message || "Failed to respond to counter offer"
      );
    }
  }
);

// Pending Transactions
export const fetchPendingTransactions = createAsyncThunk(
  "buyer/fetchPendingTransactions",
  async (_, thunkAPI) => {
    try {
      const response = await buyerService.getPendingTransactions();
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.message || "Failed to fetch pending transactions"
      );
    }
  }
);

// Transaction Details
export const fetchTransactionDetails = createAsyncThunk(
  "buyer/fetchTransactionDetails",
  async (id, thunkAPI) => {
    try {
      const response = await buyerService.getTransactionDetails(id);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.message || "Failed to fetch transaction details"
      );
    }
  }
);

// Get Categories
export const fetchCategories = createAsyncThunk(
  "buyer/fetchCategories",
  async (_, thunkAPI) => {
    try {
      const response = await buyerService.getCategories();
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.message || "Failed to fetch categories"
      );
    }
  }
);

// Get Subcategories
export const fetchSubcategoriesById = createAsyncThunk(
  "buyer/fetchSubcategoriesById",
  async (categoryId, thunkAPI) => {
    try {
      // console.log('categoryId in thunk:', categoryId);
      const response = await buyerService.getSubcategoriesById(categoryId);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.message || "Failed to fetch subcategories"
      );
    }
  }
);

// Generate Ai Description
export const generateAiDescription = createAsyncThunk(
  "buyer/generateDescription",
  async (data, thunkAPI) => {
    try {
      const response = await buyerService.generateDescription(data);
      console.log("AI API response:", response);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.message || "Failed to generate description"
      );
    }
  }
);

// Generate Ai Faqs
export const generateAiFaqs = createAsyncThunk(
  "buyer/generateFaqs",
  async (data, thunkAPI) => {
    try {
      const response = await buyerService.generateFaqs(data);
      console.log("AI API response:", response);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.message || "Failed to generate faqs"
      );
    }
  }
);

//Fetch Countries
export const fetchCountries = createAsyncThunk(
  "buyer/fetchCountries",
  async (_, { rejectWithValue }) => {
    try {
      const response = await buyerService.getCountries();
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

//Fetch States
export const fetchStates = createAsyncThunk(
  "buyer/fetchStates",
  async ({ countryId, type }, { rejectWithValue }) => {
    try {
      const response = await buyerService.getStates(countryId);
      return { data: response.data, type };
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

//Fetch Cities
export const fetchCities = createAsyncThunk(
  "buyer/fetchCities",
  async ({ stateId, type }, { rejectWithValue }) => {
    try {
      const response = await buyerService.getCities(stateId);
      return { data: response.data, type };
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

// Out of range list
export const fetchOutOfRange = createAsyncThunk(
  "buyer/fetchOutOfRange",
  async (_, { rejectWithValue }) => {
    try {
      const response = await buyerService.getOutOfRange();
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

// Admin assistance
export const adminAssistance = createAsyncThunk(
  "buyer/adminAssistance",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      console.log('Data:', data)
      const response = await buyerService.adminAssistance(id, data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

// Accept Charges
export const acceptCharges = createAsyncThunk(
  "buyer/acceptCharges",
  async (id, { rejectWithValue }) => {
    try {
      const response = await buyerService.acceptCharges(id);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

// Reject Charges
export const rejectCharges = createAsyncThunk(
  "buyer/rejectCharges",
  async (id, { rejectWithValue }) => {
    try {
      const response = await buyerService.rejectCharges(id);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

const buyerSlice = createSlice({
  name: "buyer",
  initialState: {
    profile: null,
    addresses: [],
    kycList: [],

    profileLoading: false,
    profileError: null,
    profileSuccess: null,

    addressLoading: false,
    addressError: null,
    addressSuccess: null,

    passwordLoading: false,
    passwordError: null,
    passwordSuccess: null,

    kycLoading: false,
    kycError: null,
    kycSuccess: null,

    products: [],
    productDetail: null,
    subcategories: [],
    productLoading: false,
    productError: null,

    bids: [],
    bidLoading: false,
    bidError: null,
    bidSuccess: null,

    dashboard: null,
    dashboardLoading: false,
    dashboardError: null,
    dashboardSuccess: null,

    orders: [],
    orderDetails: null,
    orderTrack: null,
    orderSummary: null,
    orderLoading: false,
    orderError: null,
    orderSuccess: null,
    orderCancelSuccess: null,
    orderPlaceSuccess: null,
    invoice: null,
    markComplete: null,
    tpiRequest: null,

    paymentMethods: [],
    checkoutSession: null,
    paymentStatus: null,

    paymentLoading: false,
    paymentError: null,
    paymentSuccess: null,

    trades: [],
    offers: [],
    loading: false,
    error: null,

    reverseBids: [],
    reverseBidDetails: null,
    reverseBidsLoading: false,
    reverseBidsError: null,
    reverseBidsStoreSuccess: null,
    reverseBidsAcceptSuccess: null,

    orderShippingDetails: null,
    orderShippingLoading: false,
    orderShippingError: null,
    orderShippingSuccess: null,

    shippingDetails: null,
    shippingDetailsLoading: false,
    shippingDetailsError: null,
    shippingDetailsSuccess: null,

    acceptOrder: null,
    acceptOrderLoading: false,
    acceptOrderError: null,
    acceptOrderSuccess: null,

    disputeOrder: null,
    disputeOrderLoading: false,
    disputeOrderError: null,
    disputeOrderSuccess: null,

    contactUs: null,
    contactUsLoading: false,
    contactUsError: null,
    contactUsSuccess: null,

    offer: {
      list: [],
      detail: null,
      categories: {
        list: [],
        loading: false,
        error: null,
      },
      subcategories: {
        list: [],
        loading: false,
        error: null,
      },
      loading: false,
      error: null,
      calculatedPrice: null,
    },

    metalCode: {
      data: "",
      loading: false,
      error: null,
    },
    specifications: {
      list: [],
      loading: false,
      error: null,
    },
    counterOffer: {
      data: null,
      loading: false,
      error: null,
    },
    pendingTransactions: {
      list: [],
      loading: false,
      error: null,
    },
    transactionDetails: {
      data: null,
      loading: false,
      error: null,
    },
    ai: {
      generatingDescription: false,
      generatingFaqs: false,
      error: null,
      description: "",
      faqs: [],
    },

    addressSelector: {
      countries: [],
      delivery: {
        states: [],
        cities: [],
      },

      billing: {
        states: [],
        cities: [],
      },

      pickup: {
        states: [],
        cities: [],
      },

      loading: {
        countries: false,
        deliveryStates: false,
        deliveryCities: false,
        billingStates: false,
        billingCities: false,
        pickupStates: false,
        pickupCities: false,
      },

      error: {
        countries: null,
        deliveryStates: null,
        deliveryCities: null,
        billingStates: null,
        billingCities: null,
        pickupStates: null,
        pickupCities: null,
      },
    },

    outOfRange: {
      data: [],
      loading: false,
      error: null,
    },

    adminAssistance: {
      loading: false,
      success: false,
      error: null,
    },
    acceptCharges: {
      loading: false,
      success: false,
      error: null,
    },
    rejectCharges: {
      loading: false,
      success: false,
      error: null,
    },
  },
  reducers: {
    clearBuyerMessages: (state) => {
      state.profileError = null;
      state.profileSuccess = null;

      state.addressError = null;
      state.addressSuccess = null;

      state.passwordError = null;
      state.passwordSuccess = null;

      state.kycError = null;
      state.kycSuccess = null;

      state.bidError = null;
      state.bidSuccess = null;

      state.dashboardError = null;
      state.dashboardSuccess = null;

      state.orderError = null;
      state.orderSuccess = null;
      state.orderCancelSuccess = null;
      state.orderPlaceSuccess = null;

      state.paymentError = null;
      state.paymentSuccess = null;

      state.reverseBidsError = null;
      state.reverseBidsStoreSuccess = null;
      state.reverseBidsAcceptSuccess = null;

      state.orderShippingError = null;
      state.orderShippingSuccess = null;

      state.shippingDetailsError = null;
      state.shippingDetailsSuccess = null;

      state.acceptOrderError = null;
      state.acceptOrderSuccess = null;

      state.disputeOrderError = null;
      state.disputeOrderSuccess = null;

      state.contactUsError = null;
      state.contactUsSuccess = null;
    },
    clearofferDetail(state) {
      state.offer.detail = null;
      state.offer.error = null;
      state.offer.loading = false;
      state.offer.calculatedPrice = null;
      state.offer.subcategories = [];
    },
    clearCategories(state) {
      state.categories.list = [];
      state.categories.loading = false;
      state.categories.error = null;
    },

    clearMetalCode: (state) => {
      state.metalCode.data = "";
      state.metalCode.loading = false;
      state.metalCode.error = null;
    },
    clearAiState: (state) => {
      state.ai.generatingDescription = false;
      state.ai.generatingFaqs = false;
      state.ai.error = null;
      state.ai.description = "";
      state.ai.faqs = [];
    },
    resetAddressStatus: (state) => {
      state.addressSuccess = false;
      state.addressError = null;
    },
    resetAddressSelector: (state) => {
      state.addressSelector.delivery.states = [];
      state.addressSelector.delivery.cities = [];

      state.addressSelector.billing.states = [];
      state.addressSelector.billing.cities = [];

      state.addressSelector.pickup.states = [];
      state.addressSelector.pickup.cities = [];

      Object.keys(state.addressSelector.loading).forEach(
        (key) => (state.addressSelector.loading[key] = false)
      );

      Object.keys(state.addressSelector.error).forEach(
        (key) => (state.addressSelector.error[key] = null)
      );
    },
    resetAdminAssistance(state) {
      state.adminAssistance = {
        loading: false,
        success: false,
        error: null,
      };
    },
    resetAcceptCharges(state) {
      state.acceptCharges = {
        loading: false,
        success: false,
        error: null,
      };
    },
    resetRejectCharges(state) {
      state.rejectCharges = {
        loading: false,
        success: false,
        error: null,
      };
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch Profile
      // Profile
      .addCase(fetchBuyerProfile.pending, (state) => {
        state.profileLoading = true;
        state.profileError = null;
        state.profileSuccess = null;
      })
      .addCase(fetchBuyerProfile.fulfilled, (state, action) => {
        state.profileLoading = false;
        state.profile = action.payload;
      })
      .addCase(fetchBuyerProfile.rejected, (state, action) => {
        state.profileLoading = false;
        state.profileError = action.payload;
      })

      .addCase(updateBuyerProfile.pending, (state) => {
        state.profileLoading = true;
        state.profileError = null;
        state.profileSuccess = null;
      })
      .addCase(updateBuyerProfile.fulfilled, (state, action) => {
        state.profileLoading = false;
        state.profile = action.payload;
        state.profileSuccess = "Profile updated successfully";
      })
      .addCase(updateBuyerProfile.rejected, (state, action) => {
        state.profileLoading = false;
        state.profileError = action.payload;
      })

      // Address
      .addCase(fetchBuyerAddresses.pending, (state) => {
        state.addressLoading = true;
        state.addressError = null;
        state.addressSuccess = null;
      })
      .addCase(fetchBuyerAddresses.fulfilled, (state, action) => {
        state.addressLoading = false;
        state.addresses = action.payload;
      })
      .addCase(fetchBuyerAddresses.rejected, (state, action) => {
        state.addressLoading = false;
        state.addressError = action.payload;
      })

      .addCase(updateBuyerAddress.pending, (state) => {
        state.addressLoading = true;
        state.addressError = null;
        state.addressSuccess = null;
      })
      .addCase(updateBuyerAddress.fulfilled, (state, action) => {
        state.addressLoading = false;
        state.addressSuccess = "Address updated successfully";
      })
      .addCase(updateBuyerAddress.rejected, (state, action) => {
        state.addressLoading = false;
        state.addressError = action.payload;
      })

      // Password
      .addCase(changeBuyerPassword.pending, (state) => {
        state.passwordLoading = true;
        state.passwordError = null;
        state.passwordSuccess = null;
      })
      .addCase(changeBuyerPassword.fulfilled, (state) => {
        state.passwordLoading = false;
        state.passwordSuccess = "Password changed successfully";
      })
      .addCase(changeBuyerPassword.rejected, (state, action) => {
        state.passwordLoading = false;
        state.passwordError = action.payload;
      })

      // KYC Upload
      .addCase(uploadBuyerKyc.pending, (state) => {
        state.kycLoading = true;
        state.kycError = null;
        state.kycSuccess = null;
      })
      .addCase(uploadBuyerKyc.fulfilled, (state) => {
        state.kycLoading = false;
        state.kycSuccess = "KYC uploaded successfully";
      })
      .addCase(uploadBuyerKyc.rejected, (state, action) => {
        state.kycLoading = false;
        state.kycError = action.payload;
      })

      // KYC List
      .addCase(fetchBuyerKycList.pending, (state) => {
        state.kycLoading = true;
        state.kycError = null;
        state.kycSuccess = null;
      })
      .addCase(fetchBuyerKycList.fulfilled, (state, action) => {
        state.kycLoading = false;
        state.kycList = action.payload;
      })
      .addCase(fetchBuyerKycList.rejected, (state, action) => {
        state.kycLoading = false;
        state.kycError = action.payload;
      })

      // All Products
      .addCase(fetchAllProducts.pending, (state) => {
        state.productLoading = true;
        state.productError = null;
      })
      .addCase(fetchAllProducts.fulfilled, (state, action) => {
        state.productLoading = false;
        state.products = action.payload;
      })
      .addCase(fetchAllProducts.rejected, (state, action) => {
        state.productLoading = false;
        state.productError = action.payload;
      })

      //Random Products
      .addCase(fetchRandomProducts.pending, (state) => {
        state.productLoading = true;
        state.productError = null;
      })
      .addCase(fetchRandomProducts.fulfilled, (state, action) => {
        state.profileLoading = false;
        state.products = action.payload;
      })
      .addCase(fetchRandomProducts.rejected, (state, action) => {
        state.productLoading = false;
        state.productError = action.payload;
      })

      // Product Detail
      .addCase(fetchProductDetail.pending, (state) => {
        state.productLoading = true;
        state.productError = null;
      })
      .addCase(fetchProductDetail.fulfilled, (state, action) => {
        state.productLoading = false;
        state.selectedProduct = action.payload;
      })
      .addCase(fetchProductDetail.rejected, (state, action) => {
        state.productLoading = false;
        state.productError = action.payload;
      })

      // Filter Products
      .addCase(filterBuyerProducts.pending, (state) => {
        state.productLoading = true;
        state.productError = null;
      })
      .addCase(filterBuyerProducts.fulfilled, (state, action) => {
        state.productLoading = false;
        state.products = action.payload;
      })
      .addCase(filterBuyerProducts.rejected, (state, action) => {
        state.productLoading = false;
        state.productError = action.payload;
      })

      // Get Subcategories
      .addCase(fetchSubcategories.pending, (state) => {
        state.productLoading = true;
        state.productError = null;
      })
      .addCase(fetchSubcategories.fulfilled, (state, action) => {
        state.productLoading = false;
        state.subcategories = action.payload;
      })
      .addCase(fetchSubcategories.rejected, (state, action) => {
        state.productLoading = false;
        state.productError = action.payload;
      })

      // Fetch Bid List
      .addCase(fetchMyBids.pending, (state) => {
        state.bidLoading = true;
        state.bidError = null;
      })
      .addCase(fetchMyBids.fulfilled, (state, action) => {
        state.bidLoading = false;
        state.bids = action.payload;
      })
      .addCase(fetchMyBids.rejected, (state, action) => {
        state.bidLoading = false;
        state.bidError = action.payload;
      })

      // Place Bid
      .addCase(placeBid.pending, (state) => {
        state.bidLoading = true;
        state.bidError = null;
        state.bidSuccess = null;
      })
      .addCase(placeBid.fulfilled, (state, action) => {
        state.bidLoading = false;
        state.bidSuccess = action.payload;
      })
      .addCase(placeBid.rejected, (state, action) => {
        state.bidLoading = false;
        state.bidError = action.payload;
      })

      // Accept Bid
      .addCase(acceptBid.pending, (state) => {
        state.bidLoading = true;
        state.bidError = null;
        state.bidSuccess = null;
      })
      .addCase(acceptBid.fulfilled, (state, action) => {
        state.bidLoading = false;
        state.bidSuccess = action.payload;
      })
      .addCase(acceptBid.rejected, (state, action) => {
        state.bidLoading = false;
        state.bidError = action.payload;
      })

      // Reject Bid
      .addCase(rejectBid.pending, (state) => {
        state.bidLoading = true;
        state.bidError = null;
        state.bidSuccess = null;
      })
      .addCase(rejectBid.fulfilled, (state, action) => {
        state.bidLoading = false;
        state.bidSuccess = action.payload;
      })
      .addCase(rejectBid.rejected, (state, action) => {
        state.bidLoading = false;
        state.bidError = action.payload;
      })
      .addCase(fetchBuyerDashboard.pending, (state) => {
        state.dashboardLoading = true;
        state.dashboardError = null;
      })
      .addCase(fetchBuyerDashboard.fulfilled, (state, action) => {
        state.dashboardLoading = false;
        state.dashboard = action.payload;
      })
      .addCase(fetchBuyerDashboard.rejected, (state, action) => {
        state.dashboardLoading = false;
        state.dashboardError = action.payload;
      })

      // My Orders
      .addCase(fetchMyOrders.pending, (state) => {
        state.orderLoading = true;
        state.orderError = null;
      })
      .addCase(fetchMyOrders.fulfilled, (state, action) => {
        state.orderLoading = false;
        state.orders = action.payload;
      })
      .addCase(fetchMyOrders.rejected, (state, action) => {
        state.orderLoading = false;
        state.orderError = action.payload;
      })

      // Order Details
      .addCase(fetchOrderDetails.pending, (state) => {
        state.orderLoading = true;
        state.orderError = null;
      })
      .addCase(fetchOrderDetails.fulfilled, (state, action) => {
        state.orderLoading = false;
        state.orderDetails = action.payload;
      })
      .addCase(fetchOrderDetails.rejected, (state, action) => {
        state.orderLoading = false;
        state.orderError = action.payload;
      })

      // Order Cancel
      .addCase(cancelOrder.pending, (state) => {
        state.orderLoading = true;
        state.orderError = null;
        state.orderCancelSuccess = null;
      })
      .addCase(cancelOrder.fulfilled, (state, action) => {
        state.orderLoading = false;
        state.orderCancelSuccess = action.payload;
      })
      .addCase(cancelOrder.rejected, (state, action) => {
        state.orderLoading = false;
        state.orderError = action.payload;
      })

      // Order Track
      .addCase(trackOrder.pending, (state) => {
        state.orderLoading = true;
        state.orderError = null;
      })
      .addCase(trackOrder.fulfilled, (state, action) => {
        state.orderLoading = false;
        state.orderTrack = action.payload;
      })
      .addCase(trackOrder.rejected, (state, action) => {
        state.orderLoading = false;
        state.orderError = action.payload;
      })

      // Order Place
      .addCase(placeOrder.pending, (state) => {
        state.orderLoading = true;
        state.orderError = null;
        state.orderPlaceSuccess = null;
      })
      .addCase(placeOrder.fulfilled, (state, action) => {
        state.orderLoading = false;
        state.orderPlaceSuccess = action.payload;
      })
      .addCase(placeOrder.rejected, (state, action) => {
        state.orderLoading = false;
        state.orderError = action.payload;
      })

      // Order Summary
      .addCase(getOrderSummary.pending, (state) => {
        state.orderLoading = true;
        state.orderError = null;
        state.orderPlaceSuccess = null;
      })
      .addCase(getOrderSummary.fulfilled, (state, action) => {
        state.orderLoading = false;
        state.orderSummary = action.payload;
      })
      .addCase(getOrderSummary.rejected, (state, action) => {
        state.orderLoading = false;
        state.orderError = action.payload;
      })

      // Generate Invoice
      .addCase(generateInvoice.pending, (state) => {
        state.orderLoading = true;
        state.orderError = null;
      })
      .addCase(generateInvoice.fulfilled, (state, action) => {
        state.orderLoading = false;
        state.invoice = action.payload;
        state.orderSuccess = "Invoice generated successfully";
      })
      .addCase(generateInvoice.rejected, (state, action) => {
        state.orderLoading = false;
        state.orderError = action.payload;
      })

      //Mark As Complete
      .addCase(markAsComplete.pending, (state) => {
        state.orderLoading = true;
        state.orderError = null;
      })
      .addCase(markAsComplete.fulfilled, (state, action) => {
        state.orderLoading = false;
        state.markComplete = action.payload;
        state.orderSuccess = "Order completed successfully";
      })
      .addCase(markAsComplete.rejected, (state, action) => {
        state.orderLoading = false;
        state.orderError = action.payload;
      })

      //Tpi Request
      .addCase(createTpiRequest.pending, (state) => {
        state.orderLoading = true;
        state.orderError = null;
      })
      .addCase(createTpiRequest.fulfilled, (state, action) => {
        state.orderLoading = false;
        state.tpiRequest = action.payload;
        state.orderSuccess = "Tpi Request Generated";
      })
      .addCase(createTpiRequest.rejected, (state, action) => {
        state.orderLoading = false;
        state.orderError = action.payload;
      })

      // Payment Methods
      .addCase(getPaymentMethods.pending, (state) => {
        state.paymentLoading = true;
        state.paymentError = null;
        state.paymentSuccess = null;
      })
      .addCase(getPaymentMethods.fulfilled, (state, action) => {
        state.paymentLoading = false;
        state.paymentMethods = action.payload;
        state.paymentSuccess = "Payment methods fetched successfully.";
      })
      .addCase(getPaymentMethods.rejected, (state, action) => {
        state.paymentLoading = false;
        state.paymentError = action.payload;
      })

      // Checkout Session
      .addCase(createCheckoutSession.pending, (state) => {
        state.paymentLoading = true;
        state.paymentError = null;
        state.paymentSuccess = null;
      })
      .addCase(createCheckoutSession.fulfilled, (state, action) => {
        state.paymentLoading = false;
        state.checkoutSession = action.payload;
        state.paymentSuccess = "Checkout session created.";
      })
      .addCase(createCheckoutSession.rejected, (state, action) => {
        state.paymentLoading = false;
        state.paymentError = action.payload;
      })

      .addCase(getPaymentStatus.pending, (state) => {
        state.paymentLoading = true;
        state.paymentError = null;
        state.paymentSuccess = null;
      })
      .addCase(getPaymentStatus.fulfilled, (state, action) => {
        state.paymentLoading = false;
        state.paymentStatus = action.payload;
        state.paymentSuccess = "Payment status fetched.";
      })
      .addCase(getPaymentStatus.rejected, (state, action) => {
        state.paymentLoading = false;
        state.paymentError = action.payload;
      })

      .addCase(getMarketData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getMarketData.fulfilled, (state, action) => {
        state.loading = false;
        state.trades = action.payload.trades || [];
        state.offers = action.payload.offers || [];
        state.bids = action.payload.bids || [];
        state.all_offers = action.payload.all_offers || [];
      })
      .addCase(getMarketData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to fetch market data";
      })

      // Fetch all reverse bids
      .addCase(fetchReverseBids.pending, (state) => {
        state.reverseBidsLoading = true;
        state.reverseBidsError = null;
      })
      .addCase(fetchReverseBids.fulfilled, (state, action) => {
        state.reverseBidsLoading = false;
        state.reverseBids = action.payload;
      })
      .addCase(fetchReverseBids.rejected, (state, action) => {
        state.reverseBidsLoading = false;
        state.reverseBidsError = action.payload;
      })

      // Store reverse bid
      .addCase(storeReverseBid.pending, (state) => {
        state.reverseBidsLoading = true;
        state.reverseBidsError = null;
        state.reverseBidsStoreSuccess = null;
      })
      .addCase(storeReverseBid.fulfilled, (state, action) => {
        state.reverseBidsLoading = false;
        state.reverseBidsStoreSuccess = "Reverse bid stored successfully";
      })
      .addCase(storeReverseBid.rejected, (state, action) => {
        state.reverseBidsLoading = false;
        state.reverseBidsError = action.payload;
      })

      // Fetch reverse bid details
      .addCase(fetchReverseBidDetails.pending, (state) => {
        state.reverseBidsLoading = true;
        state.reverseBidsError = null;
      })
      .addCase(fetchReverseBidDetails.fulfilled, (state, action) => {
        state.reverseBidsLoading = false;
        state.reverseBidDetails = action.payload;
      })
      .addCase(fetchReverseBidDetails.rejected, (state, action) => {
        state.reverseBidsLoading = false;
        state.reverseBidsError = action.payload;
      })

      // Accept reverse bid
      .addCase(acceptReverseBid.pending, (state) => {
        state.reverseBidsLoading = true;
        state.reverseBidsError = null;
        state.reverseBidsAcceptSuccess = null;
      })
      .addCase(acceptReverseBid.fulfilled, (state, action) => {
        state.reverseBidsLoading = false;
        state.reverseBidsAcceptSuccess = "Reverse bid accepted successfully";
      })
      .addCase(acceptReverseBid.rejected, (state, action) => {
        state.reverseBidsLoading = false;
        state.reverseBidsError = action.payload;
      })

      // Order Shipping Details
      .addCase(orderShippingDetails.pending, (state) => {
        state.orderShippingLoading = true;
        state.orderShippingError = null;
        state.orderShippingSuccess = null;
      })
      .addCase(orderShippingDetails.fulfilled, (state, action) => {
        state.orderShippingLoading = false;
        state.orderShippingDetails = action.payload;
        state.orderShippingSuccess =
          "Order shipping details fetched successfully";
      })
      .addCase(orderShippingDetails.rejected, (state, action) => {
        state.orderShippingLoading = false;
        state.orderShippingError = action.payload;
      })

      // Shipping Details
      .addCase(fetchShippingDetails.pending, (state) => {
        state.shippingDetailsLoading = true;
        state.shippingDetailsError = null;
        state.shippingDetailsSuccess = null;
      })
      .addCase(fetchShippingDetails.fulfilled, (state, action) => {
        state.shippingDetailsLoading = false;
        state.shippingDetails = action.payload;
        state.shippingDetailsSuccess = "Shipping details fetched successfully";
      })
      .addCase(fetchShippingDetails.rejected, (state, action) => {
        state.shippingDetailsLoading = false;
        state.shippingDetailsError = action.payload;
      })

      // Accept Order
      .addCase(acceptOrder.pending, (state) => {
        state.acceptOrderLoading = true;
        state.acceptOrderError = null;
        state.acceptOrderSuccess = null;
      })
      .addCase(acceptOrder.fulfilled, (state, action) => {
        state.acceptOrderLoading = false;
        state.acceptOrder = action.payload;
        state.acceptOrderSuccess = "Order accepted successfully";
      })
      .addCase(acceptOrder.rejected, (state, action) => {
        state.acceptOrderLoading = false;
        state.acceptOrderError = action.payload;
      })

      // Dispute Order
      .addCase(disputeOrder.pending, (state) => {
        state.disputeOrderLoading = true;
        state.disputeOrderError = null;
        state.disputeOrderSuccess = null;
      })
      .addCase(disputeOrder.fulfilled, (state, action) => {
        state.disputeOrderLoading = false;
        state.disputeOrder = action.payload;
        state.disputeOrderSuccess = "Order disputed successfully";
      })
      .addCase(disputeOrder.rejected, (state, action) => {
        state.disputeOrderLoading = false;
        state.disputeOrderError = action.payload;
      })

      // Contact Us
      .addCase(contactUs.pending, (state) => {
        state.contactUsLoading = true;
        state.contactUsError = null;
        state.contactUsSuccess = null;
      })
      .addCase(contactUs.fulfilled, (state, action) => {
        state.contactUsLoading = false;
        state.contactUs = action.payload;
        state.contactUsSuccess = "Contact us request submitted successfully";
      })
      .addCase(contactUs.rejected, (state, action) => {
        state.contactUsLoading = false;
        state.contactUsError = action.payload;
      })

      // All Offers
      .addCase(fetchAllOffers.pending, (state) => {
        state.offer.loading = true;
        state.offer.error = null;
      })
      .addCase(fetchAllOffers.fulfilled, (state, action) => {
        state.offer.loading = false;
        state.offer.list = action.payload;
      })
      .addCase(fetchAllOffers.rejected, (state, action) => {
        state.offer.loading = false;
        state.offer.error = action.payload;
      })

      //Offers Details
      .addCase(fetchOfferDetails.pending, (state) => {
        state.offer.loading = true;
        state.offer.error = null;
      })
      .addCase(fetchOfferDetails.fulfilled, (state, action) => {
        state.offer.loading = false;
        state.offer.detail = action.payload;
      })
      .addCase(fetchOfferDetails.rejected, (state, action) => {
        state.offer.loading = false;
        state.offer.error = action.payload;
      })

      // For calculate price
      .addCase(calculatePrice.fulfilled, (state, action) => {
        state.offer.calculatedPrice = action.payload;
      })

      // Get Categories
      .addCase(fetchCategories.pending, (state) => {
        state.offer.categories.loading = true;
        state.offer.categories.error = null;
      })
      .addCase(fetchCategories.fulfilled, (state, action) => {
        state.offer.categories.loading = false;
        state.offer.categories.list = action.payload;
      })
      .addCase(fetchCategories.rejected, (state, action) => {
        state.offer.categories.loading = false;
        state.offer.categories.error = action.payload;
      })

      // Get Subcategories
      .addCase(fetchSubcategoriesById.pending, (state) => {
        state.offer.subcategories.loading = true;
        state.offer.subcategories.error = null;
      })
      .addCase(fetchSubcategoriesById.fulfilled, (state, action) => {
        state.offer.subcategories.loading = false;
        state.offer.subcategories.list = action.payload;
      })
      .addCase(fetchSubcategoriesById.rejected, (state, action) => {
        state.offer.subcategories.loading = false;
        state.offer.subcategories.error = action.payload;
      })

      //Metal Code
      .addCase(fetchMetalCode.pending, (state) => {
        state.metalCode.loading = true;
        state.metalCode.error = null;
      })

      .addCase(fetchMetalCode.fulfilled, (state, action) => {
        state.metalCode.loading = false;
        state.metalCode.data = action.payload;
      })

      .addCase(fetchMetalCode.rejected, (state, action) => {
        state.metalCode.loading = false;
        state.metalCode.error = action.payload;
      })

      // Specifications
      .addCase(fetchSpecifications.pending, (state) => {
        state.specifications.loading = true;
        state.specifications.error = null;
      })
      .addCase(fetchSpecifications.fulfilled, (state, action) => {
        state.specifications.loading = false;
        state.specifications.list = action.payload;
      })
      .addCase(fetchSpecifications.rejected, (state, action) => {
        state.specifications.loading = false;
        state.specifications.error = action.payload;
      })

      // Counter Offer
      .addCase(respondCounterOffer.pending, (state) => {
        state.counterOffer.loading = true;
        state.counterOffer.error = null;
      })
      .addCase(respondCounterOffer.fulfilled, (state, action) => {
        state.counterOffer.loading = false;
        state.counterOffer.data = action.payload;
      })
      .addCase(respondCounterOffer.rejected, (state, action) => {
        state.counterOffer.loading = false;
        state.counterOffer.error = action.payload;
      })

      // Pending Transactions
      .addCase(fetchPendingTransactions.pending, (state) => {
        state.pendingTransactions.loading = true;
        state.pendingTransactions.error = null;
      })
      .addCase(fetchPendingTransactions.fulfilled, (state, action) => {
        state.pendingTransactions.loading = false;
        state.pendingTransactions.list = action.payload;
      })
      .addCase(fetchPendingTransactions.rejected, (state, action) => {
        state.pendingTransactions.loading = false;
        state.pendingTransactions.error = action.payload;
      })

      // Transaction Details
      .addCase(fetchTransactionDetails.pending, (state) => {
        state.transactionDetails.loading = true;
        state.transactionDetails.error = null;
      })
      .addCase(fetchTransactionDetails.fulfilled, (state, action) => {
        state.transactionDetails.loading = false;
        state.transactionDetails.data = action.payload;
      })
      .addCase(fetchTransactionDetails.rejected, (state, action) => {
        state.transactionDetails.loading = false;
        state.transactionDetails.error = action.payload;
      })

      // Generate Ai Description
      .addCase(generateAiDescription.pending, (state) => {
        state.ai.generatingDescription = true;
        state.ai.error = null;
        state.ai.description = "";
      })
      .addCase(generateAiDescription.fulfilled, (state, action) => {
        state.ai.generatingDescription = false;
        state.ai.description = action.payload.description || "";
      })
      .addCase(generateAiDescription.rejected, (state, action) => {
        state.ai.generatingDescription = false;
        state.ai.error = action.payload;
        state.ai.description = "";
      })

      // Generate Ai Faqs
      .addCase(generateAiFaqs.pending, (state) => {
        state.ai.generatingFaqs = true;
        state.ai.error = null;
        state.ai.faqs = [];
      })
      .addCase(generateAiFaqs.fulfilled, (state, action) => {
        state.ai.generatingFaqs = false;
        state.ai.faqs = (action.payload.faqs || []).map((f) => ({
          question: f.q,
          answer: f.a,
        }));
      })
      .addCase(generateAiFaqs.rejected, (state, action) => {
        state.ai.generatingFaqs = false;
        state.ai.error = action.payload;
        state.ai.faqs = [];
      })

      // Countries
      .addCase(fetchCountries.pending, (state) => {
        state.addressSelector.loading.countries = true;
        state.addressSelector.error.countries = null;
      })

      .addCase(fetchCountries.fulfilled, (state, action) => {
        state.addressSelector.loading.countries = false;
        state.addressSelector.countries = Array.isArray(action.payload)
          ? action.payload
          : [];
      })

      .addCase(fetchCountries.rejected, (state, action) => {
        state.addressSelector.loading.countries = false;
        state.addressSelector.error.countries = action.payload;
      })

      // States
      .addCase(fetchStates.pending, (state) => {
        state.addressSelector.loading.states = true;
        state.addressSelector.error.states = null;
      })

      .addCase(fetchStates.fulfilled, (state, action) => {
        const { data, type } = action.payload;

        state.addressSelector.loading.states = false;
        state.addressSelector[type].states = Array.isArray(data) ? data : [];
        state.addressSelector[type].cities = []; // 👈 reset cities
      })

      .addCase(fetchStates.rejected, (state, action) => {
        state.addressSelector.loading.states = false;
        state.addressSelector.error.states = action.payload;
      })

      // Cities
      .addCase(fetchCities.pending, (state) => {
        state.addressSelector.loading.cities = true;
        state.addressSelector.error.cities = null;
      })

      .addCase(fetchCities.fulfilled, (state, action) => {
        const { data, type } = action.payload;

        state.addressSelector.loading.cities = false;
        state.addressSelector[type].cities = Array.isArray(data) ? data : [];
      })

      .addCase(fetchCities.rejected, (state, action) => {
        state.addressSelector.loading.cities = false;
        state.addressSelector.error.cities = action.payload;
      })

      // Fetch Out Of Range
      .addCase(fetchOutOfRange.pending, (state) => {
        state.outOfRange.loading = true;
        state.outOfRange.error = null;
      })
      .addCase(fetchOutOfRange.fulfilled, (state, action) => {
        state.outOfRange.loading = false;
        state.outOfRange.data = action.payload;
      })
      .addCase(fetchOutOfRange.rejected, (state, action) => {
        state.outOfRange.loading = false;
        state.outOfRange.error = action.payload;
      })

      // Admin Assistance
      .addCase(adminAssistance.pending, (state) => {
        state.adminAssistance.loading = true;
        state.adminAssistance.error = null;
        state.adminAssistance.success = false;
      })
      .addCase(adminAssistance.fulfilled, (state) => {
        state.adminAssistance.loading = false;
        state.adminAssistance.success = true;
      })
      .addCase(adminAssistance.rejected, (state, action) => {
        state.adminAssistance.loading = false;
        state.adminAssistance.error = action.payload;
      })

      // Accept Charges
      .addCase(acceptCharges.pending, (state) => {
        state.acceptCharges.loading = true;
        state.acceptCharges.error = null;
        state.acceptCharges.success = false;
      })
      .addCase(acceptCharges.fulfilled, (state) => {
        state.acceptCharges.loading = false;
        state.acceptCharges.success = true;
      })
      .addCase(acceptCharges.rejected, (state, action) => {
        state.acceptCharges.loading = false;
        state.acceptCharges.error = action.payload;
      })

      // Reject Charges
      .addCase(rejectCharges.pending, (state) => {
        state.rejectCharges.loading = true;
        state.rejectCharges.error = null;
        state.rejectCharges.success = false;
      })
      .addCase(rejectCharges.fulfilled, (state) => {
        state.rejectCharges.loading = false;
        state.rejectCharges.success = true;
      })
      .addCase(rejectCharges.rejected, (state, action) => {
        state.rejectCharges.loading = false;
        state.rejectCharges.error = action.payload;
      });
  },
});

export const {
  clearBuyerMessages,
  resetAddressStatus,
  clearAiState,
  clearMetalCode,
  clearofferDetail,
  resetAdminAssistance,
  resetAcceptCharges,
  resetRejectCharges
} = buyerSlice.actions;
export default buyerSlice.reducer;
